<template>
  <v-ad-page title="广告收益">
    <v-item v-for="(item, index) in 20" :key="index" class="profit-item" />
  </v-ad-page>
</template>

<script>
import VAdPage from '@/components/AdPage'
import VItem from './item'

export default {
  components: { VAdPage, VItem },

  data() {
    return {}
  },
  computed: {},

  async created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.profit-item {
  // margin: 10px 0;
  margin-bottom: 10px;
}
</style>
